import { ConfigProvider } from 'antd';

// eslint-disable-next-line react/prop-types
const AntConfigProvider = ({ children }) => (
  <ConfigProvider
    theme={{
      components: {
        Message: {
          zIndexPopup: 1300, // due to by default 1020 index it's render under the App
        },
        Notification: {
          zIndexPopup: 1300, // due to by default 1020 index it's render under the App
        },
        Modal: {
          zIndexBase: 1300,
        },
        Segmented: {
          itemSelectedBg: '#4CAF50',
          itemSelectedColor: '#fff',
        },
      },
    }}
  >
    {children}
  </ConfigProvider>
);

export default AntConfigProvider;
